export default {
  name: 'global',
  store() {
    return {
      isMobileMenuVisible: false,
      isMinicartVisible: false,
      isPredictiveSearchVisible: false,
      isAccountPopupVisible: false,
      isCurrencyMenuVisible: false,
      isWindowScrolled: false,
      isHeaderHovered: false,
      cart: null,
      init() {
        window.addEventListener('scroll', this.onWindowScrollHandler.bind(this));
        window.addEventListener('keydown', this.onKeyDownHandler.bind(this));
        this.initHeaderHoverDetection();
        window.addEventListener('arc:action:mobile-menu-show', this.toggleMobileMenu.bind(this));
        window.addEventListener('arc:action:mobile-menu-toggle', this.toggleMobileMenu.bind(this));
        window.addEventListener('toggle-search', this.toggleSearch);
        window.addEventListener('open-search', this.openSearch);
        window.addEventListener('close-search', this.closeSearch);
        document.body.addEventListener('click', (event) => {
          // Close minicart when clicking outside
          if (this.isMinicartVisible) {
            this.isMinicartVisible = false;
            document.body.classList.remove('no-scroll');
          }

          // Close search when clicking outside
          if (this.isPredictiveSearchVisible) {
            // Check if the click is outside the search area
            const searchContainer =
              event.target.closest('[data-search-container]') ||
              event.target.closest('.search-header') ||
              event.target.closest('[data-search-input]') ||
              event.target.closest('.search-overlay');

            // If click is not within search area, close search
            if (!searchContainer) {
              this.isPredictiveSearchVisible = false;
              document.body.classList.remove('search-visible');
            }
          }
        });
        window.addEventListener('toggle-minicart', this.toggleMinicart.bind(this));
        window.addEventListener('toggle-account-popup', this.toggleAccountPopup.bind(this));
        window.addEventListener('toggle-currency-menu', this.toggleCurrencyMenu.bind(this));
        this.initLiquidAJaxCart();
        this.trackLastVisitedPage();
        this.initContinueShoppingLinks();
        this.initLastViewedSkuTracking();
      },
      get bodyClasses() {
        let classes = [];

        if (this.isMobileMenuVisible) {
          classes.push('no-scroll');
        }
        if (this.isMinicartVisible) {
          classes.push('minicart-open');
        }
        if (this.isPredictiveSearchVisible) {
          classes.push('search-open');
        }

        document.body.classList[this.isMinicartVisible ? 'add' : 'remove']('no-scroll');

        return classes || '';
      },
      toggleMobileMenu() {
        if (window.enableDebugMode) { console.log('Toggling Mobile Menu'); }
        this.isMobileMenuVisible = !this.isMobileMenuVisible;
        document.body.classList[this.isMobileMenuVisible ? 'add' : 'remove']('no-scroll');
      },
      toggleSearch() {
        this.isPredictiveSearchVisible = !this.isPredictiveSearchVisible;
        document.body.classList[this.isPredictiveSearchVisible ? 'add' : 'remove']('search-visible');
      },
      openSearch() {
        this.isPredictiveSearchVisible = true;
        document.body.classList.add('search-visible');
      },
      closeSearch() {
        this.isPredictiveSearchVisible = false;
        document.body.classList.remove('search-visible');
      },
      toggleAccountPopup() {
        this.isAccountPopupVisible = !this.isAccountPopupVisible;
        if (window.enableDebugMode) { console.log('Toggle Account Popup', this.isAccountPopupVisible); }
        // document.body.classList[this.isAccountPopupVisible ? "add" : "remove"](
        //   "no-scroll",
        // );
      },
      toggleCurrencyMenu() {
        this.isCurrencyMenuVisible = !this.isCurrencyMenuVisible;
        if (window.enableDebugMode) { console.log('Toggle Currency Menu', this.isCurrencyMenuVisible); }
        // document.body.classList[this.isCurrencyMenuVisible ? "add" : "remove"](
        //   "no-scroll",
        // );
      },
      toggleMinicart() {
        this.isMinicartVisible = !this.isMinicartVisible;
        if (window.enableDebugMode) { console.log('Toggle Minicart', this.isMinicartVisible); }
        document.body.classList[this.isMinicartVisible ? 'add' : 'remove']('no-scroll');

        document.dispatchEvent(
          new CustomEvent('toggle-minicart', {
            detail: {
              isMinicartVisible: this.isMinicartVisible
            }
          })
        );
      },
      closeMinicart() {
        this.isMinicartVisible = false;
        document.body.classList.remove('no-scroll');
      },

      initLiquidAJaxCart() {
        document.addEventListener('liquid-ajax-cart:request-end', (event) => {
          const { requestState, cart, previousCart, sections } = event.detail;

          if (requestState.requestType === 'add') {
            if (requestState.responseData?.ok) {
              this.isMinicartVisible = true;
              document.body.classList.add('no-scroll');
            }
          }

          this.cart = cart;
        });
      },
      onWindowScrollHandler() {
        const isScrolled = window.scrollY > 0;

        this.isWindowScrolled = isScrolled;
        document.body.classList[isScrolled ? 'add' : 'remove']('scrolled');

      },
      initHeaderHoverDetection() {
        const headerSelectors = ['.transparent-header', 'header'];
        function isHeaderElement(element) {
          while (element && element !== document) {
            if (headerSelectors.some((selector) => element.matches && element.matches(selector))) {
              return true;
            }
            element = element.parentElement;
          }
          return false;
        }
        document.addEventListener('mouseover', (event) => {
          if (isHeaderElement(event.target)) {
            this.isHeaderHovered = true;
            document.body.classList.add('header-hovered');
          }
        });
        document.addEventListener('mouseout', (event) => {
          if (isHeaderElement(event.target)) {
            this.isHeaderHovered = false;
            document.body.classList.remove('header-hovered');
          }
        });
      },
      onKeyDownHandler(event) {
        if (event.key === 'Escape') {
          if (window.enableDebugMode) { console.log('Escape Key Pressed'); }
          this.isMinicartVisible = false;
          this.isPredictiveSearchVisible = false;

          // Remove all search-related body classes when closing with Escape
          document.body.classList.remove('no-scroll', 'search-visible', 'search-open');
        }
      },
      initLastViewedSkuTracking() {
        const COOKIE_NAME = 'ss_lastViewed';
        const COOKIE_DAYS = 30;
        const MAX_SKUS = 20;

        window.addEventListener('arc:action:lastViewedSkuAdd', (event) => {
          const sku = event.detail?.sku;
          if (!sku) return;

          const existing = this._readLastViewedSkus(COOKIE_NAME);
          const updated = [sku, ...existing.filter(s => s !== sku)].slice(0, MAX_SKUS);

          const expires = new Date();
          expires.setTime(expires.getTime() + COOKIE_DAYS * 24 * 60 * 60 * 1000);
          document.cookie = `${COOKIE_NAME}=${encodeURIComponent(updated.join(','))};expires=${expires.toUTCString()};path=/`;
        });
      },

      _readLastViewedSkus(cookieName) {
        try {
          const cookie = document.cookie.split('; ').find(row => row.startsWith(`${cookieName}=`));
          if (!cookie) return [];
          return decodeURIComponent(cookie.split('=')[1]).split(',').filter(Boolean);
        } catch {
          return [];
        }
      },

      trackLastVisitedPage() {
        if (!window.location.pathname.startsWith('/cart')) {
          sessionStorage.setItem('last_visited_page', window.location.href);
        }
      },
      initContinueShoppingLinks() {
        const lastPage = sessionStorage.getItem('last_visited_page');
        if (!lastPage) return;
        document.querySelectorAll('[data-continue-shopping]').forEach((el) => {
          el.href = lastPage;
        });
      }
    };
  }
};
